export default __webpack_public_path__ + "static/media/the-villa2.58610851.webp";